var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoneyTransfer = function SvgMoneyTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 0h4c3.771 0 5.657 0 6.828 1.172.844.843 1.08 2.057 1.146 4.078H.026c.066-2.021.302-3.235 1.146-4.078C2.343 0 4.229 0 8 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m20 8.818-.409-.409a2.25 2.25 0 0 0-3.182 0l-.801.801a2.251 2.251 0 0 0-4.358.79v1.764a2.25 2.25 0 0 0-1.341 3.827l.409.409H8c-3.771 0-5.657 0-6.828-1.172C0 13.657 0 11.771 0 8c0-.442 0-.858.002-1.25h19.996C20 7.142 20 7.558 20 8v.818ZM4 11.25a.75.75 0 1 0 0 1.5h4a.75.75 0 1 0 0-1.5H4Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.5 9.25a.75.75 0 0 1 .75.75v4.19l.72-.72a.75.75 0 1 1 1.06 1.06l-2 2a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l.72.72V10a.75.75 0 0 1 .75-.75Zm3.97.22a.75.75 0 0 1 1.06 0l2 2a.75.75 0 1 1-1.06 1.06l-.72-.72V16a.75.75 0 1 1-1.5 0v-4.19l-.72.72a.75.75 0 1 1-1.06-1.06l2-2Z",
    clipRule: "evenodd"
  })));
};
export default SvgMoneyTransfer;